module.exports = __webpack_public_path__ + "img/ic_arrow_down_gray.05ee0349.svg";